(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-powerbank-capacity"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function kpbcFit(root){
      root.querySelectorAll('[data-kfit]').forEach(function(el){
        el.style.fontSize = '';
        var size = parseFloat(window.getComputedStyle(el).fontSize);
        while (el.scrollWidth > el.clientWidth && size > 8) {
          size -= 0.5;
          el.style.fontSize = size + 'px';
        }
      });
    }
    function kpbcInit(root){
      if (!root || root.dataset.kpbcReady) return;
      root.dataset.kpbcReady = '1';
      kpbcFit(root);
      if (root.classList.contains('kpbc--anim')) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function(entries){
            entries.forEach(function(en){
              if (en.isIntersecting) { root.classList.add('is-on'); io.disconnect(); }
            });
          }, { threshold: 0.35 });
          io.observe(root);
        } else {
          root.classList.add('is-on');
        }
      }
    }
    function kpbcAll(){ document.querySelectorAll('.kpbc').forEach(kpbcInit); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', kpbcAll); } else { kpbcAll(); }
    window.addEventListener('resize', function(){ document.querySelectorAll('.kpbc').forEach(kpbcFit); });
    document.addEventListener('shopify:section:load', function(e){
      var root = e.target.querySelector('.kpbc');
      if (root) { delete root.dataset.kpbcReady; kpbcInit(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.kpp-hero').forEach(function(root){
      var sid = root.dataset.sectionId;
      var variantsEl = document.getElementById('kpp-variants-' + sid);
      if(!variantsEl) return;
      var variants = JSON.parse(variantsEl.textContent);

      var thumbWrap = document.getElementById('kpp-thumbs-' + sid);
      var mainImg = document.getElementById('kpp-main-img-' + sid);
      var variantIdInput = document.getElementById('kpp-variant-id-' + sid);
      var qtyInput = document.getElementById('kpp-qty-' + sid);
      var atcBtn = document.getElementById('kpp-atc-' + sid);
      var mobileBar = document.getElementById('kpp-mobile-atc-' + sid);
      var priceNowEls = root.querySelectorAll('.kpp-price-now');
      var form = root.querySelector('.kpp-form');
      var optionGroups = root.querySelectorAll('.kpp-variant-pills');

      if(thumbWrap && mainImg){
        thumbWrap.querySelectorAll('img').forEach(function(t){
          t.addEventListener('click', function(){
            thumbWrap.querySelectorAll('img').forEach(function(x){ x.classList.remove('active'); });
            t.classList.add('active');
            mainImg.src = t.dataset.full;
          });
        });
      }

      var prevBtn = root.querySelector('.kpp-nav-prev');
      var nextBtn = root.querySelector('.kpp-nav-next');
      function goToOffset(offset){
        if(!thumbWrap || !mainImg) return;
        var thumbs = Array.prototype.slice.call(thumbWrap.querySelectorAll('img'));
        if(!thumbs.length) return;
        var currentIndex = 0;
        for(var i = 0; i < thumbs.length; i++){
          if(thumbs[i].classList.contains('active')){ currentIndex = i; break; }
        }
        var nextIndex = (currentIndex + offset + thumbs.length) % thumbs.length;
        thumbs.forEach(function(x){ x.classList.remove('active'); });
        thumbs[nextIndex].classList.add('active');
        mainImg.src = thumbs[nextIndex].dataset.full;
        thumbs[nextIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
      if(prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); goToOffset(-1); });
      if(nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); goToOffset(1); });

      function getSelectedOptions(){
        var selected = [];
        optionGroups.forEach(function(group){
          var picked = group.querySelector('.kpp-pill.selected');
          selected.push(picked ? picked.dataset.value : null);
        });
        return selected;
      }

      function findMatchingVariant(selected){
        return variants.find(function(v){
          return v.options.every(function(opt, i){ return opt === selected[i]; });
        });
      }

      function formatMoney(cents){
        return '€' + (cents / 100).toFixed(2).replace('.', ',');
      }

      function updateForVariant(variant){
        if(!variant) return;
        variantIdInput.value = variant.id;
        priceNowEls.forEach(function(el){ el.textContent = formatMoney(variant.price); });
        if(atcBtn){
          atcBtn.disabled = !variant.available;
          atcBtn.textContent = variant.available
            ? (root.dataset.atcLabel || '🛒 Toevoegen aan winkelwagen')
            : 'Tijdelijk uitverkocht';
        }
      }

      optionGroups.forEach(function(group){
        group.querySelectorAll('.kpp-pill').forEach(function(pill){
          pill.addEventListener('click', function(){
            group.querySelectorAll('.kpp-pill').forEach(function(p){ p.classList.remove('selected'); });
            pill.classList.add('selected');
            var match = findMatchingVariant(getSelectedOptions());
            updateForVariant(match);
          });
        });
      });

      var minusBtn = root.querySelector('.kpp-qty-minus');
      var plusBtn = root.querySelector('.kpp-qty-plus');
      if(minusBtn) minusBtn.addEventListener('click', function(){
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      });
      if(plusBtn) plusBtn.addEventListener('click', function(){
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
      });

      /* ---------- Cart drawer (theme drawer: #cart-drawer) ---------- */
      var DRAWER_SECTION = 'cart-drawer-section';

      function goToCartPage(){
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        window.location.href = base + 'cart';
      }

      function openDrawer(){
        var themeDrawer = document.getElementById('cart-drawer');
        var dlg = themeDrawer ? themeDrawer.querySelector('dialog') : null;
        if(!themeDrawer || !dlg) return false;
        if(dlg.open) return true;
        if(typeof themeDrawer.open === 'function'){ try { themeDrawer.open(); } catch(err){} }
        if(!dlg.open && typeof themeDrawer.showDialog === 'function'){ try { themeDrawer.showDialog(); } catch(err){} }
        if(!dlg.open){ try { dlg.showModal(); } catch(err){} }
        return dlg.open;
      }

      function showCart(addResult, cart){
        if(!document.getElementById('cart-drawer')){ goToCartPage(); return; }

        /* Tell the theme the cart changed: it refreshes the drawer contents + the cart count */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'kpp-hero-' + sid,
            data: {
              source: 'kpp-hero',
              itemCount: cart.item_count,
              productId: variants[0] ? String(variants[0].product_id) : '',
              sections: (addResult && addResult.sections) ? addResult.sections : {}
            }
          }
        }));

        /* Open the side drawer (if the theme hasn't already) */
        setTimeout(function(){
          if(!openDrawer()) goToCartPage();
        }, 300);
      }

      function addToCart(e){
        if(e) e.preventDefault();
        if(atcBtn.disabled) return;
        var originalText = atcBtn.textContent;
        var addResult = null;
        atcBtn.textContent = 'Toevoegen...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantIdInput.value, 10), quantity: parseInt(qtyInput.value || '1', 10) }],
            sections: DRAWER_SECTION,
            sections_url: window.location.pathname
          })
        })
        .then(function(res){ if(!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function(result){ addResult = result; return fetch('/cart.js'); })
        .then(function(res){ return res.json(); })
        .then(function(cart){
          atcBtn.textContent = 'Toegevoegd ✓';
          showCart(addResult, cart);
          setTimeout(function(){ atcBtn.textContent = originalText; }, 1800);
        })
        .catch(function(){
          atcBtn.textContent = 'Mislukt — probeer opnieuw';
          setTimeout(function(){ atcBtn.textContent = originalText; }, 2000);
        });
      }
      if(form) form.addEventListener('submit', addToCart);

      var mobileSubmit = mobileBar ? mobileBar.querySelector('[data-mobile-submit]') : null;
      if(mobileSubmit) mobileSubmit.addEventListener('click', function(){ addToCart(); });

      window.addEventListener('scroll', function(){
        if(window.innerWidth <= 900 && mobileBar){
          mobileBar.classList.toggle('show', window.scrollY > 600);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.kpt-tabs').forEach(function(root){
      root.querySelectorAll('.kpt-tab-btn').forEach(function(btn){
        btn.addEventListener('click', function(){
          root.querySelectorAll('.kpt-tab-btn').forEach(function(b){ b.classList.remove('active'); });
          root.querySelectorAll('.kpt-panel').forEach(function(p){ p.classList.remove('active'); });
          btn.classList.add('active');
          root.querySelector('[data-panel="' + btn.dataset.tab + '"]').classList.add('active');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.kpc-carousel').forEach(function (root) {
      var urlTag = root.querySelector('[data-recommendations-url]');
      if (!urlTag) return; // already server-rendered with cards, nothing to fetch
      var url = urlTag.textContent.trim();

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var freshTrack = temp.querySelector('.kpc-track');
          var wrapper = root.querySelector('[data-recommendations-wrapper]');
          if (freshTrack && wrapper) {
            wrapper.innerHTML = freshTrack.innerHTML;
            initCarousel(root);
          }
        });
    });

    function initCarousel(root) {
      var track = root.querySelector('.kpc-track');
      var dotsWrap = root.querySelector('.kpc-dots');
      var cards = track.querySelectorAll('.kpc-card');
      if (!cards.length) { root.style.display = 'none'; return; }

      function visibleCount() {
        if (window.innerWidth <= 560) return 2;
        if (window.innerWidth <= 900) return 3;
        return 5;
      }
      function buildDots() {
        dotsWrap.innerHTML = '';
        var pages = Math.ceil(cards.length / visibleCount());
        for (var i = 0; i < pages; i++) {
          var d = document.createElement('button');
          if (i === 0) d.classList.add('active');
          d.addEventListener('click', (function (idx) {
            return function () {
              var cw = cards[0].getBoundingClientRect().width + 12;
              track.scrollTo({ left: idx * cw * visibleCount(), behavior: 'smooth' });
            };
          })(i));
          dotsWrap.appendChild(d);
        }
      }
      function updateActive() {
        var cw = cards[0].getBoundingClientRect().width + 12;
        var page = Math.round(track.scrollLeft / (cw * visibleCount()));
        dotsWrap.querySelectorAll('button').forEach(function (d, i) { d.classList.toggle('active', i === page); });
      }
      root.querySelector('.kpc-prev').addEventListener('click', function () {
        var cw = cards[0].getBoundingClientRect().width + 12;
        track.scrollBy({ left: -cw * visibleCount(), behavior: 'smooth' });
      });
      root.querySelector('.kpc-next').addEventListener('click', function () {
        var cw = cards[0].getBoundingClientRect().width + 12;
        track.scrollBy({ left: cw * visibleCount(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(updateActive); });
      buildDots();
      window.addEventListener('resize', buildDots);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
